<template>
  <div>
    <el-form :inline="true" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="AddGalex">添加分类</el-button>
      </el-form-item>
    </el-form>
    <el-form :inline="true" :model="formInline">
        <el-form-item label="分类名称:">
          <el-input size="small" v-model="formInline.name" placeholder="输入分类名称"></el-input>
        </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表  show-summary :summary-method="getSummaries"  -->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <!-- <el-table-column align="center" prop="id" label="id">
      </el-table-column> -->
      <el-table-column align="center" label="类名">
        <template slot-scope="scope">
          <div class="img_box" :title="scope.row.icon">
            <img :src="scope.row.icon" @error="imgerrorfun" style="background: #999;" />
            <p><a :href="scope.row.icon" target="_blance">{{ scope.row.name }}</a></p>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="introduce" label="描述">
      </el-table-column>
      <el-table-column align="center" prop="sort" label="排序">
      </el-table-column>
      <el-table-column align="center" prop="type" label="类型">
        <template slot-scope="scope">
          <p>{{  scope.row.type == 'video'?'视频分类':'资讯类型'}}</p>
        </template>
      </el-table-column>
      
      <!-- <el-table-column align="center" label="链接">
        <template slot-scope="scope">
          <img src="" alt="" srcset="">
          <a :href="scope.row.icon" target="_blank">{{ scope.row.icon }}</a>
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="是否禁用">
        <template slot-scope="scope">
          <el-row v-if="!scope.row.disable">
              <span>否</span>
            </el-row>
            <el-row v-if="scope.row.disable">
              <span>是</span>
            </el-row>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="setupTime" label="创建时间">
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 添加Galex -->
    <el-dialog :title="isEdit ? '编辑分类' : '添加分类'" :visible.sync="addGalexVisible" width="30%"
      @click="addGalexVisible = false">
      <el-form label-width="120px" :model="editForm" :rules="Rules" ref="editForm">
        <el-form-item label="类名" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入类名"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="introduce">
          <el-input size="small" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="editForm.introduce" auto-complete="off" placeholder="请输入描述"></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="icon">
          <el-input size="small" v-model="editForm.icon" auto-complete="off" placeholder="请输入链接"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input size="small" type="number" v-model="editForm.sort" auto-complete="off" onkeyup="this.editForm.sort=this.editForm.sort.replace(/\D|^0/g)" placeholder="请输入终端"></el-input>
        </el-form-item>
        <el-form-item v-if="isEdit" label="禁用">
          <el-radio v-model="editForm.disable" :label="true">是</el-radio>
          <el-radio v-model="editForm.disable" :label="false">否</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addGalexVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitUser('editForm')">{{
          isEdit ? '保存' : '添加' }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { Categorys, AddCategory , UpdateCategory } from '../../api/userMG'
import bgimg from '../../assets/img/logo.png'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      // rules表单验证
      formInline: {
        from: 1,
        limit: 10,
        name:""
      },
      isEdit: false,
      addGalexVisible: false,
      editForm: {
        "name": "",
        "icon": "",
        "introduce": "",
        "sort": 0
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      Rules: {
        name: [{ required: true, message: '请输入类名', trigger: 'blur' }],
        introduce: [{ required: true, message: '请输入描述', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
      },
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    imgerrorfun(e){
      e.target.src = bgimg
    },
    // 获取转入列表
    getdata(parameter) {
      this.loading = true
      Categorys(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.list
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.from
            // this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },

    //Galex显示编辑界面
    AddGalex() {
      this.editForm = {
        "name": "",
        "icon": "",
        "introduce": "",
        "sort": 0
      }
      this.isEdit = false
      this.addGalexVisible = true
    },
    handleEdit(row) {
      this.editForm = {
        "name": row.name,
        "icon": row.icon,
        "introduce": row.introduce,
        "sort": row.sort,
        "id":row.id,
        "disable":row.disable
      }
      this.isEdit = true
      this.addGalexVisible = true
    },
    // 添加
    submitUser(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.loading = true
          if (this.isEdit) {
            UpdateCategory(this.editForm).then(res => {
                this.loading = false
                this.addGalexVisible = false
                if (res.code == 0) {
                  console.log(res)
                  this.$message({
                    type: 'success',
                    message: '编辑成功！'
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              }).catch(err => {
                this.addGalexVisible = false
                this.loading = false
                this.$message.error('编辑失败，请稍后再试！')
              })
            return
          }
          AddCategory(this.editForm)
            .then(res => {
              this.loading = false
              this.addGalexVisible = false
              if (res.code == 0) {
                console.log(res)
                this.$message({
                  type: 'success',
                  message: '添加成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            }).catch(err => {
              this.addGalexVisible = false
              this.loading = false
              this.$message.error('添加失败，请稍后再试！')
            })
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageSize = parm.pageSize
      this.formInline.from = (parm.currentPage - 1) * (this.pageparm.pageSize) + 1
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    search() {
        this.pageparm.currentPage = 1
        this.formInline.from = 1
        this.getdata(this.formInline)
      }
  }
}
</script>
  
<style scoped>
img{width: 30px;}
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
.img_box{display: flex;justify-content: flex-start;align-items: center;}
.img_box p{margin-left: 10px;}
</style>
  
   
   


// WEBPACK FOOTER //
// src/views/news/categorys.vue